import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=23472444&scoped=true&"
import script from "./ForgetPwd.vue?vue&type=script&lang=js&"
export * from "./ForgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPwd.vue?vue&type=style&index=0&id=23472444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23472444",
  null
  
)

export default component.exports